export type WebsocketCredentials = {
  accessToken: string
  dpopProof?: string
}

export type WebsocketConfig = {
  getCredentials: () => Promise<WebsocketCredentials>
}

let config: WebsocketConfig | null = null

export function configureWebsocket(options: WebsocketConfig) {
  config = options
}

export function clearWebsocketConfiguration() {
  config = null
}

export function getWebsocketCredentialsProvider() {
  if (!config) {
    throw new Error("Websocket configuration has not been set")
  }
  return config.getCredentials
}
